import { cn } from '@/lib/utils';

interface Props {
  valor: number | string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * A NOTA, e só a nota (Douglas 04/09/2026: "esta estrela está péssima nos
 * lugares que ela está, não consigo ver o número da nota, tire ela").
 *
 * Substitui o antigo `NotaPrimeStar`, que desenhava uma estrela e jogava o
 * número DENTRO dela — a 8px no tamanho `sm`, com as pontas da estrela
 * roubando a área do texto. O número é a informação; a moldura estava
 * comendo ela.
 *
 * Os tamanhos batem com o resto da barra: `sm` usa os mesmos 12,5px
 * font-display bold tabular-nums dos outros chips do header, então a Nota
 * Prime lê igual a Bio, Aparelhos e Disparos.
 */
const TAMANHOS = {
  sm: 'text-[12.5px]',
  md: 'text-[16px]',
  lg: 'text-[22px]',
};

export function NotaPrimeValor({ valor, size = 'md', className }: Props) {
  return (
    <span
      className={cn(
        'font-display font-bold leading-none tabular-nums tracking-tight text-primary',
        TAMANHOS[size],
        className,
      )}
    >
      {valor}
    </span>
  );
}
